import axios from "axios";
import { defineStore } from "pinia";

//This store is used by the forgot password page so make sure nothing in here triggers a 401
export const useAuthStore = defineStore("authStore",() => {
    const apiUrl = "api/v1/user/";
    
    async function validateNewPassword(username: string, password: string) {
        try {
            let encodedPassword = encodeURIComponent(password);
            const data = await axios.post(`${apiUrl}actions/validate-password`, {username, password: encodedPassword});
            return data.data;
        } catch (error: any) {
            console.error(error?.response?.statusText);
            return `Error encountered while trying to validate new password (${error?.response?.statusText}).`;
        }
    }

    function validateResetCode(userInfo: string, resetCode: string) {
        try {
            let encodedResetCode = encodeURIComponent(resetCode);
            return axios.get(`${apiUrl}${userInfo}/reset-code/${encodedResetCode}/verify`);
        } catch (error: any) {
            console.error(error?.response?.statusText);
        }
    }

    function sendPasswordResetRequest(userInfo: string) {
        try {
            return axios.get(`${apiUrl}${userInfo}/reset-password`);
        } catch (error: any) {
            console.error(error?.response?.statusText);
        }
    }

    function postPasswordChangeInformation(userInfo: string, password: string, resetCode: string) {
        try {
            let encodedPassword = encodeURIComponent(password);
            let encodedResetCode = encodeURIComponent(resetCode);
            return axios.post(`${apiUrl}${userInfo}/reset-password`, {password: encodedPassword, resetCode: encodedResetCode});
        } catch (error: any) {
            console.error(error?.response?.statusText);
        }
    }

    return {
        validateNewPassword,
        validateResetCode,
        sendPasswordResetRequest,
        postPasswordChangeInformation,
    };
});